import { createContext, useContext, useMemo, useState } from "react";

export const AppContext = createContext();

// A partir desta largura o menu lateral fica fixo ao lado do conteúdo; abaixo (celular, tablet, notebook 1024) abre por cima
export const DRAWER_FIXED_MIN_WIDTH = 1100;

export const AppProvider = ({ children }) => {
  // Context Values
  const [appState, setAppState] = useState(() => ({
    // Celular/tablet abre com o menu fechado (no desktop ele fica fixo ao lado)
    drawerOpened: window.matchMedia(`(min-width: ${DRAWER_FIXED_MIN_WIDTH}px)`).matches,
    fullBackdropOpened: false,
    simpleBackdropOpened: false,
  }));

  // Referência estável: consumidores só re-renderizam quando o estado muda
  const value = useMemo(() => [appState, setAppState], [appState]);

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

// App Context Hook
export const useAppContext = () => useContext(AppContext);
